<template>
  <span>{{parsedDate}}</span>
</template>

<script>
import dateHelper from 'src/helpers/date';

export default {
  props: [
    'date',
  ],
  computed: {
    parsedDate() {
      return dateHelper(this.date);
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Date.vue?dd5a384c
 **/